export enum LocaleStorage {
  PartnerDashboardLocale = 'partner-dashboard-locale',
}
